export default __webpack_public_path__ + "images/29_1_image.jpg";